import React, { useState } from "react";
import AlarmIcon from "../../assets/images/alarm.png";
import LockIcon from "../../assets/images/lock-circle.svg";
import { getDistanceFromLatLonInKm } from "../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import CommunityPostShare from "../SingleUserPost/UserPostShare/CommunityPostLike.jsx";
import { fetchAllEvents } from "../../redux/posts/posts.action";

function CommunityPostCard({ data, coords, index }) {
  const darktheme = useSelector((state) => state.features.settings.darktheme);
  const dispatch = useDispatch();
  const [reportModal, setReportModal] = useState(false);
  const [, setActivePostId] = useState("");

  const getData = () => {
    dispatch(fetchAllEvents(true));
  };
  const reportPost = (id) => {
    setActivePostId(id);
    setReportModal(!reportModal);
  };

  return (
    <>
      <div className="border-b-[8px] mb-[1.5rem]  border-b-[#49496106]">
        <div className="flex justify-between">
          <div className="flex">
            <div className="w-[40px] h-[40px] bg-black rounded-[50%]">
              {data?.media?.image?.length > 0 && (
                <img
                  src={data?.userImage}
                  alt="icon"
                  className="w-full object-cover rounded-[50%] h-full"
                />
              )}
            </div>
            <div className="ml-[.5rem] font-SF-Pro-Regular">
              <h4 className="capitalize font-SF-Pro-Regular text-[14px] font-[510] text-[#1C2024]">
                {data?.displayName || data?.username}
              </h4>
              <div className="flex text-[12px] items-center text-[#667085]">
                <img
                  src={LockIcon}
                  alt="icon"
                  className="w-[18px] mr-[.3rem] h-[18px]"
                />

                <p className="text-[12px] font-SF-Pro-Regular capitalize text-[#667085] font-[400] ">
                  {data?.community?.communityName}
                </p>
                <p className="w-[.20rem]  h-[.20rem] mx-[.3rem] bg-[#EAECF0] rounded-[50%] "></p>
                <p className="text-[12px] text-[#667085] ">4d ago</p>
              </div>
            </div>
          </div>
          <div className="flex">
            <div className="mr-2">
              <div className="text-[#FC5C65]  flex gap-[5px] bg-[#FC5C651A] rounded-[21px] px-[8px] py-[5px]  ml-[6px]">
                <p className="text-[12px] font-semibold">
                  {getDistanceFromLatLonInKm(
                    coords?.latitude,
                    coords?.longitude,
                    data?.coords?.latitude,
                    data?.coords?.longitude
                  )}
                </p>
                <p className="text-[12px] font-semibold"> km</p>
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <p className="w-full my-[.7rem] w-[90%] lg:w-[80%]  font-SF-Pro-Regular font-[400] text-[#1C2024]">
            {data?.text}
          </p>

          {data?.category?.title && (
            <button
              style={{ background: data?.category?.labelBgColor }}
              className={`flex  justify-center text-[12px] px-[8px] py-[4px] rounded-[25px] items-center `}
            >
              <img
                src={AlarmIcon}
                alt="icon"
                className="object-contain w-[12px]  mr-[.3rem] h-[12px] "
              />{" "}
              <p className="font-Inter font-[400] text-[#1C2024]">
                {" "}
                {data?.category?.title}
              </p>
            </button>
          )}

          {data?.media?.images?.length === 0 ? (
            ""
          ) : (
            <div className="bg-black mt-2 w-full h-[231px] rounded-[4px]">
              <img
                src={data?.media?.images[0]}
                alt="visual"
                className="w-full h-full object-cover rounded-[4px]"
              />
            </div>
          )}

          <CommunityPostShare
            theme={darktheme}
            index={index}
            selectedPost={data}
            getData={getData}
            reportPost={reportPost}
          />
        </div>
      </div>
    </>
  );
}

export default CommunityPostCard;
